const ResultState = {
    LOADING: 'loading',
    ERROR_FETCHING: 'error_fetching',
    NO_RESULTS: 'no_results',
    INIT_SUCCESS: 'init_success',
    RESULTS_FETCHED: 'results_fetched',
    INIT_ERROR: 'init_error',
    SAVE_ERROR: 'save_error',
    UPDATE_ERROR: 'update_error',
    UPDATE_SUCCESS: 'update_success',
    CREATING_RESULTS: 'creating_results'
};

export default ResultState;
